// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard":"styles_componentsMapCard__1UtrE","merchantName":"styles_merchantName__1mKRd"};